module.exports = __webpack_public_path__ + "img/Kjokken.909bde21.jpg";